import { AlertTriangle, Receipt } from 'lucide-react';

export default function FloatingActionBar({ hasWarning, relatedInvoices = [], onOpenInvoice }) {
  // Don't render if nothing to show
  if (!hasWarning && relatedInvoices.length === 0) return null;

  return (
    <div
      className="floating-action-bar fixed bottom-8 left-1/2 -translate-x-1/2 z-50 flex items-center gap-4 no-print"
      style={{
        background: '#1a1a2e',
        color: 'white',
        borderRadius: '9999px',
        padding: '12px 24px',
        boxShadow: '0 8px 32px rgba(26, 26, 46, 0.4)',
        border: '1px solid rgba(201, 168, 76, 0.5)',
      }}
      data-testid="floating-action-bar"
    >
      {hasWarning && (
        <div
          className="flex items-center gap-2 text-sm font-medium px-3 py-1 rounded-full"
          style={{ background: 'rgba(220, 38, 38, 0.2)', color: '#fca5a5' }}
          data-testid="fab-warning"
        >
          <AlertTriangle className="w-4 h-4" />
          Payment exceeds 100%
        </div>
      )}

      {/* Related invoices indicator */}
      {relatedInvoices.length > 0 && (
        <div className="flex items-center gap-2">
          {relatedInvoices.map(inv => (
            <button
              key={inv.id}
              onClick={() => onOpenInvoice && onOpenInvoice(inv.id)}
              className="flex items-center gap-1.5 px-3 py-1 rounded-full text-xs font-medium transition-colors"
              style={{ background: 'rgba(201,168,76,0.15)', color: '#c9a84c' }}
              title={`${inv.invoice_no} — ${inv.status || 'draft'}`}
            >
              <Receipt className="w-3 h-3" />
              {inv.invoice_no}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
